module.exports = __webpack_public_path__ + "static/media/soth.5cce7de1.png";